var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paragraphs.length)?_c('div',{directives:[{name:"links-directive",rawName:"v-links-directive"}],staticClass:"vuw-rich-text",domProps:{"innerHTML":_vm._s(_vm.paragraphs.join(''))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }